import { PageSizeUtil } from '@/modules/viewer/utils/page-size.util.ts';

export const GC_TIME = 5 * 60 * 1000; // 5 минут

export const PAGE_SIZE = PageSizeUtil.calc();
